export interface AppState {
    state: 'authenticated' | 'authenticated-blocked' | 'anonymous';
}

export class InitialAppState implements AppState {
    state: 'authenticated' | 'authenticated-blocked' | 'anonymous' = 'anonymous';
}
